import { render, staticRenderFns } from "./CommentsCard.vue?vue&type=template&id=2af3a500&scoped=true"
import script from "./CommentsCard.vue?vue&type=script&lang=js"
export * from "./CommentsCard.vue?vue&type=script&lang=js"
import style0 from "./CommentsCard.vue?vue&type=style&index=0&id=2af3a500&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af3a500",
  null
  
)

export default component.exports